<template>
  <div class="classManage" id="classManage">
    <div class="breadcrumb">
      班级管理
      <el-button class="right_f" type="primary" @click="openDialog(0)"
        >添加班级</el-button
      >
      <el-button class="right_f" type="primary" @click="cancel">返回</el-button>
    </div>

    <div class="com-list">
      <el-table :data="list">
        <el-table-column prop="name" label="班级" width="500px">
        </el-table-column>
        <el-table-column inline-template label="操作">
          <span>
            <el-button type="text" size="small" @click="openDialog(1, row)"
              >修改班级名称</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="deleteClassConfirm($index, row)"
              >删除</el-button
            >
          </span>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      :title="title"
      v-model="classVisible"
      :modal-append-to-body="false"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item
          label="班级名称"
          prop="name"
          :label-width="formLabelWidth"
        >
          <el-input
            type="text"
            v-model="form.name"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveClass" :disabled="disabled"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    let checkName = (rule, value, callback) => {
      if (value) {
        if (value.trim()) {
          callback();
        } else {
          callback(new Error("班级名称不能为空"));
        }
      } else {
        callback(new Error("请输入班级名称"));
      }
    };

    return {
      list: [],
      formLabelWidth: "100px",
      classVisible: false,
      departName: this.$util.getUrlParam("departName") || "",
      departId: this.$util.getUrlParam("departid") || 0,
      rootUnid: this.$util.getUrlParam("rootUnid") || 0,
      operateId: "",
      disabled: false,
      rules: {
        name: [
          { required: true, message: "请输入班级名称", trigger: "blur" },
          { validator: checkName },
        ],
      },
      form: {
        name: "",
      },
      title: "添加班级",
    };
  },
  computed: mapState({ user: (state) => state.user }),
  mounted() {
    //获取该院系下的班级列表
    this.getClassList();
  },
  methods: {
    //获取院系下的班级列表
    getClassList() {
      let url = this.$util.domain + "/adminapi/v1/campus/department/classlist";
      this.$http({
        url,
        method: "POST",
        body: JSON.stringify({
          departId: this.departId * 1,
          department: this.departName,
          rootUnid: this.rootUnid * 1,
        }),
      }).then((response) => {
        if (response.data.error == 10000) {
          if (response.data.data && response.data.data.length) {
            this.list = response.data.data;
          }
        }
      });
    },
    //返回
    cancel() {
      location.href = `/#/xiaoyuan/GX/departmentManage?unid=${this.rootUnid}`;
    },
    //添加班级

    saveClass() {
      let url =
        this.$util.domain + "/adminapi/v2/campus/department/newIncrease";
      this.disabled = true; //禁用保存按钮；
      setTimeout(() => {
        this.disabled = false;
      }, 3000);

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$http({
            url,
            method: "POST",
            body: JSON.stringify({
              rootUnid: this.rootUnid * 1,
              classId: this.operateId * 1,
              className: this.form.name.trim(),
              department: this.departName,
              departId: this.departId * 1,
            }),
          }).then((response) => {
            if (response.data.error == 10000) {
              this.classVisible = false;
              this.$util.successMsg(response.data.message);
              this.getClassList();
            } else {
              this.$util.errorMsg(response.data.message);
            }
          });
        }
      });
    },
    //删除班级确认框
    deleteClassConfirm($index, row) {
      this.$confirm(`您确定要删除班级“${row.name}”吗？`, "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.deleteClass($index, row.id);
        })
        .catch(() => {
          //取消删除的回调
        });
    },
    //删除班级
    deleteClass($index, id) {
      let url =
        this.$util.domain + "/adminapi/v1/campus/department/deleteclass";
      this.$http({
        url,
        method: "POST",
        body: JSON.stringify({
          classId: id,
          rootUnid: this.rootUnid * 1,
        }),
      }).then((response) => {
        if (response.data.error == 10000) {
          this.list.splice($index, 1);
          this.$util.successMsg(response.data.message);
        } else {
          this.$util.errorMsg(response.data.message);
        }
      });
    },
    //打开对话框;type: 0代表新增；1代表编辑；
    openDialog(type, row) {
      this.classVisible = true;
      if (type == 0 && this.$refs.form) {
        this.title = "添加班级";
        this.$refs.form.resetFields();
        this.form.name = "";
        this.operateId = "0";
      } else if (type == 1) {
        this.title = "编辑班级名称";
        this.form.name = row.name;
        this.operateId = row.id;
      }
    },
  },
};
</script>

<style scoped>
#classManage {
  padding-bottom: 20px;
}

.cancel {
  position: absolute;
  right: 20px;
}

.addClass {
  right: 90px;
}
</style>



// WEBPACK FOOTER //
// classManage.vue?5f77c990